import { ASTCall } from '../ast';
import { Context, Func, SqlExpression } from '../types';
import { ExprType } from '../expr_types';
import {
  assertArgShape,
  assertKwargShape,
  typecheckExpression,
  TypecheckWarning,
} from '../typecheck';
import { evalExpression } from '../eval';

import { exprToSql } from '../sql';

// Function to negate a boolean
export const not: Func = {
  typecheck(
    ctx: Context,
    call: ASTCall,
    warnings?: Array<TypecheckWarning>
  ): ExprType {
    assertArgShape(call, 1, 1);
    assertKwargShape(call, [], false);

    const argType = typecheckExpression(ctx, call.args[0], warnings);

    if (argType.ty !== 'boolean') {
      warnings?.push(
        "Argument to 'not' must be a boolean.  Other types may not behave as expected."
      );
    }

    return { ty: 'boolean' };
  },

  eval(ctx: Context, call: ASTCall): unknown {
    const v = evalExpression(ctx, call.args[0]);
    return !v;
  },

  toSql(ctx: Context, call: ASTCall): SqlExpression {
    const sql = exprToSql(ctx, call.args[0]);

    return {
      expr: `NOT (${sql.expr})`,
      stage: sql.stage,
      unitExpr: sql.unitExpr,
      error: sql.error,
      trace: null,
    };
  },
};
